import Keycloak from 'keycloak-js';

const env = process.env.REACT_APP_ENV_DEPLOY;

const url = () => {
    switch (env) {
        case('prod') :
            return 'https://auth.pemmdb.entsoe.eu/auth';
        case('prod-amprion') :
            return 'https://auth.pemmdb.entsoe.eu/auth';
        case('prod-amprion-backup') :
            return 'https://auth.pemmdb-prod.rtei-europe.eu/auth';
        case ('uat-amprion'):
            return 'https://auth.pemmdb-uat.entsoe.eu/auth';
        case ('dev'):
        case ('int'):
        default :
            return 'https://pemmdb-auth.rtei-europe.com/auth';

    }
}
const clientId = () => {
    switch (env) {
        case('dev'):
            return 'react-app-dev';
        case ('int'):
            return 'react-app-int';
        case ('uat-amprion'):
            return 'react-app-uat';
        case('prod') :
            return 'react-app-prod';
        case('prod-amprion') :
            return 'react-app-prod';
        case('prod-amprion-backup') :
            return 'react-app-prod';
        default :
            return 'react-local';

    }
}


const keycloak = new Keycloak({
    url: window._env_.KEYCLOAK_URL !== "%KEYCLOAK_URL%" ? window._env_.KEYCLOAK_URL : url(),
    realm: 'pemmdb',
    clientId: window._env_.KEYCLOAK_CLIENT_ID !== "%KEYCLOAK_CLIENT_ID%" ? window._env_.KEYCLOAK_CLIENT_ID : clientId(),
    onLoad: 'login-required'
});

export default keycloak;
